
<app-nav-bar></app-nav-bar>
<!-- <app-navbar></app-navbar> -->


<router-outlet></router-outlet>

<app-topscroll></app-topscroll>
<app-footer></app-footer>
